(function(app) {

    app.provider("userDelegateApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};
                 
                    service.getCurrentUserDelegate = function () {
                        return complianceHubApiGateway.get("/UserDelegates/CurrentUserDelegate");
                    };

                    service.getUserDelegatePermissions = function () {
                        return complianceHubApiGateway.get("/UserDelegates/Permissions");
                    };

                    service.createUserDelegate = function (userDelegate) {
                        return complianceHubApiGateway.post("/UserDelegates", userDelegate);
                    };
                    
                    service.removeUserDelegate = function (userDelegateId) {
                        return complianceHubApiGateway.delete("/UserDelegates/" + userDelegateId);
                    };

                    service.updateUserDelegateRoles = function (userDelegateId, userDelegate) {
                        return complianceHubApiGateway.put("/UserDelegates/" + userDelegateId + "/Roles", userDelegate);
                    };
                   
                    return service;
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line